/**
 * @fileoverview Send an enterprise configuration to be applied to the current account.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {SubmitRequest} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/submitrequest';

/**
 * @param {EnterpriseConfiguration} configuration
 * @param {AbortSignal} abortSignal
 * @return {Promise<void>}
 */
export function submit(configuration, abortSignal) {
  const request = new SubmitRequest({configuration});

  const route = new Uri(Routes.submit());
  return doRequest('SUBMIT', abortSignal, route, 'POST', request.toJSON());
}
